import Validator from "./Validator";
import Collection from "../models/Collection";

export default class Model {

    constructor( base_url ) {

        this._base_url   = base_url;
        this.response    = null;
        this.validator   = null;

    }

    setOptions( options = {} ){

    }

    getKeyValue(key){

        if(this[key] !== 'undefined'){
            return this[key];
        }

        return null;
    }

    load(id, onDone, onError){

        let self = this,
            url  = this._base_url + '/' + id;

        axios.get(url, {} ).then(function (response) {

            if( response.status ===  200 ){

                if(typeof response.data.data === 'undefined'){

                    self.setOptions( response.data );

                } else {
                    self.setOptions( response.data.data );
                }

                if(onDone){

                    console.log('onDone');
                    onDone( response );
                }
            }

        }).catch(function (error) {

            if(onError){
                onError(error.response);
            }

        });

        return this;
    }

    save(onDone, onError, onFinally, url) {

        let self= this;

        url = typeof url === 'undefined' ? this._base_url : url;

        if( this.id ){

            url  += '/' + this.id;
            this.put(onDone, onError, onFinally, url);

        } else {

            this.post(onDone, onError, onFinally, url);
        }

        return this;
    }

    post(onDone, onError, onFinally, url)
    {
        let self   = this;
        url        = typeof url === 'undefined' ? this._base_url : url;

        axios.post(url, self.toJson() )

        .then(function (response) {

            if( response.status ===  200 ){

                self.setOptions( response.data.data );

                if(onDone){
                    onDone( response );
                }
            }

        }).catch(function (error) {

            if(onError){
                onError(error.response);
            }

        }).finally(function () {

            if(onFinally){

                onFinally();
            }
        });

        return this;
    }

    put(onDone, onError, onFinally, url)
    {
        let self   = this;
        url        = typeof url === 'undefined' ? this._base_url : url;

        axios.put(url, self.toJson() )

            .then(function (response) {

                if( response.status ===  200 ){

                    self.setOptions( response.data.data );

                    if(onDone){
                        onDone( response );
                    }
                }

            }).catch(function (error) {

            if(onError){
                onError(error.response);
            }

        }).finally(function () {

            if(onFinally){

                onFinally();
            }
        });

        return this;
    }

    getKey(key){

        return this[key];
    }

    validate(){

        if(this.validator instanceof Validator){

            return this.validator.validate(this);
        }

        return null;
    }


    static find(id)
    {
        let obj = new this;

        return obj.load(id)
    }

    static fetch(page, url){

        let model = this,
            self  = new this();

        if (page === undefined) {
            page = 1;
        }

        if (url === undefined) {
            url = self.base_url;
        }

        return new Promise((resolve, reject) => {

            return axios({
                method: 'get',
                url : url,
                params : {
                    page : parseInt(page),
                },
            })
                .then(function (response) {

                    if( response.status ===  200 ){

                        let    c = new Collection(),
                            data = response.data.data;

                        c.links = response.data.links;
                        c.meta  = response.data.meta;

                        for(let i = 0, max = data.length; i < max; i++) {

                            let x = new model(data[i]);

                            c.data.push( x )
                        }

                        resolve(c);
                    }

                }).catch(function (error) {

                    reject(error)

                });
        });

    }

}



// WEBPACK FOOTER //
// ./resources/js/core/Model.js